import React from 'react'

function Expand(props) {
	return (
		<svg
			className="icon"
			width="1em"
			height="1em"
			viewBox="0 0 24 24"
			{...props}
		>
			<g
				fill="none"
				fillRule="evenodd"
				strokeLinecap="round"
				stroke="currentColor"
			>
				<path d="M10 20H4v-6M14 4h6v6" />
			</g>
		</svg>
	)
}

const MemoExpand = React.memo(Expand)
export default MemoExpand
